import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import PointIssueHistoryListContainer from '../../containers/point/PointIssueHistoryListContainer';
import { POINT_PAGE_NAME } from '../../constants/service/app/pointConstants';

const PointIssueHistoryList = () => {
  return (
    <PageTemplate pageName={POINT_PAGE_NAME.POINT_ISSUE_HISTORY_LIST}>
      <PointIssueHistoryListContainer />
    </PageTemplate>
  );
};

export default PointIssueHistoryList;
